import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import i18next from 'i18next';

import './AreaAdditionForm.scss';

class AreaAdditionForm extends Component {
    defaultState = {
        newDeliveryAreaTag: '',
        newDeliveryAreaEstimatedTime: '0',
        newDeliveryAreaOrderFee: '0',
        newDeliveryAreaMinimumOrderPrice: '0',
        newDeliveryAreaCompanyMinimumOrderPrice: undefined,
        newDeliveryAreaAddToPool: false
    };
    state = { ...this.defaultState };

    constructor(props) {
        super(props);

        this.isEligbleForSubmition = this.isEligbleForSubmition.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleAddToPoolCheck = this.handleAddToPoolCheck.bind(this);
        this.handleDeliveryAreaSubmit = this.handleDeliveryAreaSubmit.bind(this);
    }

    isEligbleForSubmition() {
        return (
            this.props.isEligbleForSubmition() &&
            this.state.newDeliveryAreaTag &&
            this.state.newDeliveryAreaEstimatedTime &&
            this.state.newDeliveryAreaOrderFee &&
            (this.state.newDeliveryAreaMinimumOrderPrice || this.state.newDeliveryAreaCompanyMinimumOrderPrice)
        );
    }

    handleInputChange(inputName, value) {
        this.setState({ [inputName]: value });
    }

    handleAddToPoolCheck(event, { checked }) {
        this.setState({newDeliveryAreaAddToPool: checked});
    }

    handleDeliveryAreaSubmit(event) {
        this.props.addNewDeliveryAreas({
            tag: this.state.newDeliveryAreaTag,
            estimatedTime: this.state.newDeliveryAreaEstimatedTime,
            orderFee: this.state.newDeliveryAreaOrderFee,
            minimumOrderPrice: this.state.newDeliveryAreaMinimumOrderPrice,
            companyMinimumOrderPrice: this.state.newDeliveryAreaCompanyMinimumOrderPrice,
        }, this.props.deliveryZones, this.state.newDeliveryAreaAddToPool);
        this.setState({ ...this.defaultState });
    }

    renderFormInput(options) {
        return (
            <Form.Input
                type={options.type}
                label={options.title}
                placeholder={options.title}
                required
                value={this.state[options.stateProp]}
                error={options.error}
                onChange={(event, { value }) => this.handleInputChange(options.stateProp, value)}
            />
        );
    }

    render() {
        const { addToPool } = this.props;

        return (
            <Form onSubmit={this.handleDeliveryAreaSubmit}>
                <Form.Group>
                    {this.renderFormInput({type: 'text', title: i18next.t('areaName'), stateProp: 'newDeliveryAreaTag'})}
                </Form.Group>
                <Form.Group>
                    {this.renderFormInput({
                        type: 'number',
                        title: i18next.t('estimatedDeliveryTime') + ` (${i18next.t('inMinutes')})`,
                        error: !this.state.newDeliveryAreaEstimatedTime,
                        stateProp: 'newDeliveryAreaEstimatedTime'
                    })}
                    {this.renderFormInput({
                        type: 'number',
                        title: i18next.t('deliveryOrderFee'),
                        error: !this.state.newDeliveryAreaOrderFee,
                        stateProp: 'newDeliveryAreaOrderFee'
                    })}
                    {this.renderFormInput({
                        type: 'number',
                        title: i18next.t('minimumDeliveryOrderPrice'),
                        error: !this.state.newDeliveryAreaMinimumOrderPrice,
                        stateProp: 'newDeliveryAreaMinimumOrderPrice'
                    })}
                    {this.renderFormInput({
                        type: 'number',
                        title: i18next.t('minimumCompanyDeliveryOrderPrice'),
                        stateProp: 'newDeliveryAreaCompanyMinimumOrderPrice'
                    })}
                </Form.Group>
                {addToPool &&
                    <Form.Group>
                        <Form.Checkbox
                            label={i18next.t('addToDeliveryAreasPool')}
                            onClick={this.handleAddToPoolCheck} />
                    </Form.Group>
                }
                <Form.Group>
                    <Form.Button
                        color='blue'
                        content={i18next.t('add')}
                        disabled={!this.isEligbleForSubmition()} />
                </Form.Group>
            </Form>
        );
    }
}

AreaAdditionForm.propTypes = {
    addNewDeliveryAreas: PropTypes.func,
    isEligbleForSubmition: PropTypes.func,
    deliveryZones: PropTypes.array,
    addToPool: PropTypes.bool,
    
};

export default AreaAdditionForm;
